<template>
    <div class="panel-master-container">
        <div id="show-hide-panel-button" @click="showHidePanel" class="show-hide-panel-button">
            <div id="button-arrow" class="button-arrow"></div>
        </div>
        <div id="panel-container" class="panel-container">       
            <div class="panel-header">
                <div class="panel-header-icon"></div>
                <div>Parámetros oceanográficos del Mar Menor</div>       
            </div>
            <!-- MAP LAYERS -->
            <div class="separator">Capas de mapa</div>
            <panelLayers></panelLayers>

            <!-- TIMELINE -->
            <div class="separator">Histórico de mediciones</div>
            <panelTimeline></panelTimeline>

            <!-- METADATA & FILTER -->
            <div class="separator" style="padding-bottom: 9px; padding-top: 5px;">Metadatos y filtros</div>
            <!-- aquí iría el v-if FiltroOrMeta -->
            <div class="pestana-container">
                <div id="pestana1" class="pestana" @click="showHidePestana('meta')">Metadatos</div>
                <div id="pestana2" class="pestana out" @click="showHidePestana('filtro')">Filtrar</div>
            </div>
            <div v-if="this.activePestana == 'meta'">
                <panelMetadata></panelMetadata> 
            </div>
            <div v-if="this.activePestana == 'filtro'">
                <panelFilter></panelFilter>
            </div>
        </div>
    </div>
</template>

<script>
  // Components
  import panelLayers from '@/components/mapparams/panelLayers'
  import panelTimeline from '@/components/mapparams/panelTimeline'
  import panelMetadata from '@/components/mapparams/panelMetadata'
  import panelFilter from '@/components/mapparams/panelFilter'

  export default {
    name: 'panel',
    data: function () {
        return {
            activePestana: 'meta',
        }
    },
    components: {
        panelLayers,
        panelTimeline,
        panelMetadata,
        panelFilter
    },
    methods: {
        showHidePanel(){
            var panelButton = document.getElementById("show-hide-panel-button");
            panelButton.classList.toggle("hide");
            var panelContainer = document.getElementById("panel-container");
            panelContainer.classList.toggle("hide");
            var buttonArrow = document.getElementById("button-arrow");
            buttonArrow.classList.toggle("right");
        },
        activate(index) {
			this.active = index;
		},
        showHidePestana(section){
            this.activePestana = section;
            let pestana1 = document.getElementById("pestana1");
            let pestana2 = document.getElementById("pestana2");
            pestana1.classList.toggle("out");
            pestana2.classList.toggle("out");
        },
        
    }
  }
</script>

<style scoped>
   
    .panel-header-icon {
        background-image: url('~@/assets/img/params/panel-icon-params.svg');
        background-repeat: no-repeat;
        background-position: center;
        height: 50px;
        width: 50px;
        margin-right: 15px;
    }
    

    /* **********   ANIMATIONS   ************ */
    #button-arrow,.panel-separator,.panel-separator-dark,.triangle,.triangle-dark,.panel-text-section-dark,.panel-text-1-dark,.panel-container,.panel-container-dark,.show-hide-panel-button,.show-hide-panel-button-dark,.button-layer-main,.button-light,.pestana {
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }

    /* Pestañas */
    .pestana-container {
        display: flex;
        flex-direction: row;
        min-height: 3rem;
        background-color: #c6dde2;
    }
    .pestana {
        background-color: #F4FAFE;
        width: 50%;
        display: flex;      
        justify-content: center;
        align-items: center;
        /* border-right: 1px solid darkgray;  
        border-top: 1px solid darkgray; */
        cursor: pointer;
        font-size: 0.9rem;
        color: #36627b;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-shadow: 0px -2px 3px rgba(0,0,0,0.1);
    }
    .out{
        background-color: #C6DDE2;
        color: #748D9D;
        /* border-bottom: 1px solid darkgray;
        border-top: 1px solid #b2c6ca;   */
    }


</style>



// WEBPACK FOOTER //
// src/components/mapparams/panel.vue